import React from "react";
import { MarkdownContent } from "utils/markdown/markdown-content";

export const RefundPolicy = () =>  <MarkdownContent path={require("../content/refund-policy.md")} title="Refund Policy" />;

